import { render, staticRenderFns } from "./AsignacionTurno.vue?vue&type=template&id=e4f14e54"
import script from "./AsignacionTurno.vue?vue&type=script&lang=js"
export * from "./AsignacionTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports